export const UnitListTestPageObject = (currentUnitLegacyId: string | undefined) => ({
    getType: () => "UnitList",

    current: () => currentUnitLegacyId ?? "",
});
